module.exports = __webpack_public_path__ + "img/copy-06.69add4b9.svg";